import type { ReactNode } from "react";
import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fonts,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";

export function PlaySubpage({
  header,
  summary,
  children,
}: {
  readonly header: ReactNode;
  readonly summary?: string;
  readonly children: ReactNode;
}) {
  return (
    <main {...stylex.props(styles.room)}>
      {header}
      {summary !== undefined && (
        <p {...stylex.props(styles.summary)}>{summary}</p>
      )}
      <div {...stylex.props(styles.body)}>{children}</div>
    </main>
  );
}

const styles = stylex.create({
  room: {
    boxSizing: "border-box",
    width: "100%",
    minWidth: 0,
    flex: 1,
    marginInline: "auto",
    maxWidth: 1200,
    paddingInline: {
      default: spacing.space32,
      "@media (min-width: 1024px)": {
        default: spacing.space64,
        ":is([data-rail] *)": spacing.space32,
      },
    },
    paddingTop: spacing.space32,
    paddingBottom: spacing.space48,
    minHeight: "100svh",
    fontFamily: fonts.sans,
    color: colors.foreground,
  },
  summary: {
    margin: 0,
    paddingTop: spacing.space16,
    fontSize: fontSizes.small,
    lineHeight: "18px",
    color: colors.subtle,
  },
  body: { paddingTop: spacing.space24 },
});
